import { all } from "redux-saga/effects";
import dashboardSaga from "../../features/store/dashboardSaga";
/** Start - Academy Related Imports */
import isoFileManagementSaga from "../../features/components/academy/iso-file-management/store/iso-file-management.saga";
import courseInstanceSaga from "../../features/components/academy/start-course-instance/store/start-course-instance.saga";
import createCourseSaga from "../../features/components/academy/create-course/store/create-course.saga";
import viewCourseSaga from "../../features/components/academy/view-course/store/view-course.saga";
import ViewCourseTemplateSaga from "../../features/components/academy/view-course-templates/store/view-course-template.saga";
import FileManagement from "../../features/components/academy/file-management/store/file-management.saga";
import viewDeployedCourseInstanceSaga from "../../features/components/academy/view-deployed-course-instance/store/vdc-instance.saga";
/** End - Academy Related Imports */

export function* sagas() {
  yield all([
    dashboardSaga(),
    isoFileManagementSaga(),
    courseInstanceSaga(),
    viewCourseSaga(),
    createCourseSaga(),
    ViewCourseTemplateSaga(),
    FileManagement(),
    viewDeployedCourseInstanceSaga(),
  ]);
}
